
// Pending warehouse order row of the "From warehouse orders" window. The circle on the left selects the
// order for the purchase; tapping the rest of the row pushes its lines.
class BuyOrderWarehouseOrderCell extends UITableViewCell
{
    private selectButton:MUIButton = null;
    private documentLabel:MUILabel = null;
    private dateLabel:MUILabel = null;
    private sourceLabel:MUILabel = null;
    private destinationLabel:MUILabel = null;

    // Called with the order when the selection circle is tapped
    selectionTarget:any = null;
    selectionAction:(order:WarehouseOrder) => void = null;

    awakeFromHTML(){
        this.selectButton = MUIOutlet(this, "select-btn", "MUIButton");
        this.selectButton.setAction(this, function(this:BuyOrderWarehouseOrderCell){
            if (this.selectionAction != null) this.selectionAction.call(this.selectionTarget, this._item);
        });

        this.documentLabel = MUIOutlet(this, "document-lbl", "MUILabel");
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.sourceLabel = MUIOutlet(this, "source-lbl", "MUILabel");
        this.destinationLabel = MUIOutlet(this, "destination-lbl", "MUILabel");

        this.accessoryType = UITableViewCellAccessoryType.DisclosureIndicator;
        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:WarehouseOrder = null;
    set item(item:WarehouseOrder){
        this._item = item;
        let dtf = MUIWebApplication.sharedInstance().delegate.dateTimeFormatter as MIODateFormatter;

        this.documentLabel.text = item.documentID;
        this.dateLabel.text = dtf.stringFromDate(item.stockDate);
        this.sourceLabel.text = item.originName;
        this.destinationLabel.text = item.destinationName;
    }

    set checked(value:boolean){
        if (value) MUICoreLayerAddStyle(this.selectButton.layer, "on");
        else MUICoreLayerRemoveStyle(this.selectButton.layer, "on");
    }
}

// "Also include the products below their minimum stock" row with its on/off switch
class BuyOrderWarehouseOrderOptionCell extends UITableViewCell
{
    private switchButton:MUISwitchButton = null;

    changeTarget:any = null;
    changeAction:(value:boolean) => void = null;

    awakeFromHTML(){
        this.switchButton = MUIOutlet(this, "include-min-stock-switch", "MUISwitchButton");
        this.switchButton.setOnChangeValue(this, function(this:BuyOrderWarehouseOrderOptionCell, control:MUISwitchButton, value:boolean){
            if (this.changeAction != null) this.changeAction.call(this.changeTarget, value);
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set checked(value:boolean){
        this.switchButton.on = value;
    }
}
